import _ from 'lodash'
import getTitle from "./getTitle";

export default function getAliasName(item = {}, objPath = '', titlePath = '') {
  if (!_.isEmpty(titlePath) && !!_.get(item, titlePath)) return _.get(item, titlePath);

  if (_.has(item, objPath + '_name')) return _.get(item, objPath + '_name');

  return getTitle(_.get(item, objPath));
}
